import { Button } from "@mui/material";
import { Checkbox, Grid, Paper, MenuItem, Select } from "@mui/material";
import { useState, useEffect, useCallback, useContext, Suspense, useMemo, SetStateAction } from "react";
import { CustomInput, CustomSelectInput } from "../../../../../../shared/CustomInput";
import { CoveredDependents } from "../../../../../../shared/enrollment/coveredDependents";
import PlanActions from "../../../../../../shared/enrollment/planActions/PlanActions";
import PlanHeader from "../../../../../../shared/enrollment/planCode/PlanHeader";
import { AuthContext, PaycheckContext, ThemeContext } from "../../../../../../../contexts";
import { CoverageDetails } from "../../../../../../shared/enrollment";
import { useHistory, useLocation } from "react-router-dom";
import { dateTimeZoneConverter, manualDateComparator } from "../../../../../../../utils/commonFunctions/date";

import LinkIcon from "@mui/icons-material/Link";

import { PlanFormProps } from "../../../../../../../types/components/enrollmentProps.types";
import { getHealthPlanEligibleDependents } from "../../../../../../../utils/commonFunctions/groupEnrollment/eligibleDependents";
import { Member } from "../../../../../../../types/employee.types";
import { PremiumRateCoverage } from "../../../../../../../types/plan.types";
import { numberToDollarStr } from "../../../../../../../utils/commonFunctions/dollar";
import {
	AddIntercityHPandGLTDEnrollmentPayload,
	CommonDetails,
	CoverageCode,
	StandardDetails
} from "../../../../../../../types/enrollment.types";
import { RELATIONSHIP } from "../../../../../../../constants/relationship";
import { AddEnrollmentPayload } from "../../../../../../../utils/api/enrollment/enrollment";
import { api } from "../../../../../../../utils/api";
import { EligiblityDialogProps } from "../../../../../../../types/components/eligiblityDialogProps.types";
import { generateHealthPlanWaiveEnrollmentPayload } from "../../../../../../../utils/commonFunctions/groupEnrollment/enrollment";
import { CustomFormDialogType, CustomWaiveForm } from "../../../../../../../types/components/dialogProps.types";
import { LazyCustomFormDialog, LazyCustomWaiveFormDialog } from "../../../../../../shared";
import { getCurrentDate } from "../../../../../../../utils/commonFunctions/date";
import EligiblityDialog from "../../../../../VEBEnrollment/eligiblityDialogs/EligiblityDialog";
import { Health_Plan_Brochure_SBC } from "../../../../../../../assets";

import "./intercityHealthPlanForm.css";
import { dollarize } from "../../../../../../../utils/commonFunctions/dollarize";
import { trackPromise } from "react-promise-tracker";
import { WaiveCoverageFormType } from "../../../../../../../types/waiveDialogForm.types";
import { generateICIGLTDPlanWaiveEnrollmentPayload } from "../../../../../../../utils/commonFunctions/ICIEnrollment/ICICoreEnrollment/ICICoreEnrollment";

const IntercityHealthPlanForm = ({ dependents, openEnrollment, getEnrollmentInitData }: PlanFormProps): JSX.Element => {
	const [waiveReason, setWaiveReason] = useState("");
	const [enrollmentStandardDetails, setEnrollmentStandardDetails] = useState<StandardDetails[]>([]);
	const [eligibleDependents, setEligibleDependents] = useState<Member[]>([]);
	const [coverageDetails, setCoverageDetails] = useState<any[]>([]);
	const [GLTDcoverageDetails, setGLTDCoverageDetails] = useState<any[]>([]);
	const [employeePremium, setEmployeePremium] = useState<number>(0);
	const [coveredDependents, setCoveredDependents] = useState<Member[]>([]);
	const { theme } = useContext(ThemeContext);
	const [dependentPremium, setDependentPremium] = useState<number>(0);
	const [totalPremium, setTotalPremium] = useState<number>(0);
	const [customFormDialogProps, setCustomFormDialogProps] = useState<CustomWaiveForm>();
	const [combinedTotalPremium, setCombinedTotalPremium] = useState(0);
	const { member } = useContext(AuthContext);
	const { paycheck } = useContext(PaycheckContext);
	const location = useLocation();
	const history = useHistory();
	const [GLTDPremiumAmount, setGLTDPremiumAmount] = useState<number | null>(null);
	const [GLTDPlan, setGLTDPlan] = useState<any | null>(null);
	const [anotherInsurance, setAnotherInsurance] = useState<any>({
		has_another_group_insurance: false,
		another_group_insurance: null
	});
	const [isAgreeTerms, setIsAgreeTerms] = useState<boolean>(false);
	const [waiveCoverageForm, setWaiveCoverageForm] = useState<WaiveCoverageFormType>({
		waive_reason: "",
		other_waive_coverage: "",
		waive_employee_cost: false
	});
	const [submitWaiveFormStatus, setSubmitWaiveFormStatus] = useState<boolean>(false);
	const [eligiblityDialogProps, setEligiblityDialogProps] = useState<EligiblityDialogProps | any>({
		openDialog: false,
		handleCloseEligiblityDialog: () =>
			setEligiblityDialogProps(
				Object.assign({}, eligiblityDialogProps, {
					openDialog: false
				})
			),
		eligibleDependents: [],
		ineligibleDependents: [],
		ineligibleRelationshipDependents: [],
		groupPlanName: "ICI Health Plan"
	});

	const handleChangeIsAgreeTerms = useCallback(
		(event: any) => {
			const { checked } = event.target;

			setIsAgreeTerms(checked);
		},
		[isAgreeTerms]
	);

	const handleChangeOtherInsurance = useCallback(
		(event: any) => {
			const { name, value, checked } = event.target;

			if (name === "has_another_group_insurance") {
				setAnotherInsurance(Object.assign({}, anotherInsurance, { [name]: checked }));
			} else {
				setAnotherInsurance(Object.assign({}, anotherInsurance, { [name]: value }));
			}
		},
		[anotherInsurance]
	);

	const urlSearchParams: URLSearchParams = useMemo(() => new URLSearchParams(location.search), [location.search]);

	// console.log("waive form state", waiveCoverageForm);

	const handleWaiveEnrollment = useCallback(async () => {
		if (member === null || openEnrollment === null) {
			return;
		}
		const { standardDetails, commonDetails } = generateICIGLTDPlanWaiveEnrollmentPayload(
			member,
			openEnrollment,
			waiveCoverageForm
		);

		// console.log("Waive Coverage Payloadsss", waiveCoverageForm);
		const enrollmentPayload: AddEnrollmentPayload = {
			standard_details: standardDetails,
			common_details: commonDetails
		};
		const response = await api.enrollment.addEnrollment(enrollmentPayload);
		const step = urlSearchParams.get("step");
		if (response) {
			getEnrollmentInitData(false);
		}
		history.push(`?step=${step}&stage=2`);
	}, [getEnrollmentInitData, history, member, openEnrollment, urlSearchParams, waiveCoverageForm]);

	const handleWaiveReasonChange = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
		const { value, name, checked, type } = event.target;

		setWaiveCoverageForm((prevValue: any) => {
			return {
				...prevValue, // Using spread operator for a shallow copy
				[name]: type === "checkbox" ? checked : value
			};
		});
	}, []);

	const handleWaiveSubmition = useCallback(
		(waiveCoverageForm: WaiveCoverageFormType) => {
			setCustomFormDialogProps(
				Object.assign({}, customFormDialogProps, {
					openDialog: false
				})
			);
			handleWaiveEnrollment();
		},
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[customFormDialogProps, waiveCoverageForm]
	);

	const handleWaiveSubmitClick = useCallback(() => {
		setSubmitWaiveFormStatus((prevValue: any) => !prevValue);
	}, []);

	const handleWaiveButtonClick = useCallback(() => {
		setCustomFormDialogProps(
			Object.assign({}, customFormDialogProps, {
				openDialog: true,
				title: "Waivers Coverage Form",
				description:
					"The Group Health Plan has been offered to me and after seriously considering benefits I have decided not to enroll myself or my dependents in the Plan. I understand that i and my dependents must wait until the next open enrollment period unless a change of family and/or job status occur",

				inputFields: [
					{
						label: "Coverage Elsewhere",
						name: "waive_reason",
						type: "textfield",
						onChange: handleWaiveReasonChange,
						value: waiveCoverageForm.waive_reason,
						placeholder: "Name of carrier"
					},
					{
						label: "Employee Cost",
						name: "waive_employee_cost",
						type: "checkbox",
						onChange: handleWaiveReasonChange,
						value: waiveCoverageForm.waive_employee_cost,
						placeholder: ""
					},
					{
						label: "Other",
						name: "other_waive_coverage",
						type: "textfield",
						onChange: handleWaiveReasonChange,
						value: waiveCoverageForm.other_waive_coverage,
						placeholder: "State the other reason"
					}
				],
				actions: [
					{
						label: "Cancel",
						callback: () =>
							setCustomFormDialogProps(
								Object.assign({}, customFormDialogProps, {
									openDialog: false
								})
							)
					},
					{
						label: "Yes",
						callback: () => handleWaiveSubmitClick()
					}
				]
			})
		);
	}, [customFormDialogProps, handleWaiveReasonChange, handleWaiveSubmitClick, waiveCoverageForm]);

	const handleDialogClose = () => {
		setCustomFormDialogProps(
			Object.assign({}, customFormDialogProps, {
				openDialog: false
			})
		);
	};

	const handleSelectDependent = useCallback((event: React.ChangeEvent<HTMLInputElement>, dependent: Member) => {
		const { checked } = event.target;
		if (checked === true) {
			setCoveredDependents((prevCoveredDependents: Member[]) =>
				Object.assign([], [...prevCoveredDependents, dependent])
			);
		} else {
			setCoveredDependents((prevCoveredDependents: Member[]) => {
				const _selectedDependents = prevCoveredDependents.filter(
					(selectedDependent: Member) => dependent.SSN !== selectedDependent.SSN
				);
				return _selectedDependents;
			});
		}
	}, []);

	const getPremiumAmount = useCallback(
		(premiumRateCoverage: PremiumRateCoverage): string => {
			let premiumAmount = "";
			if (paycheck) {
				if (premiumRateCoverage.premium_type === "FIXED") {
					premiumAmount =
						(paycheck.pay_frequency === "WEEKLY"
							? premiumRateCoverage.weekly_premium
							: premiumRateCoverage.monthly_premium) + "";
					premiumAmount = `${numberToDollarStr(Number(premiumAmount))}`;
				} else if (premiumRateCoverage.premium_type === "PERCENTAGE") {
					premiumAmount =
						(paycheck.pay_frequency === "WEEKLY"
							? premiumRateCoverage.weekly_premium
							: premiumRateCoverage.monthly_premium) + "";
					premiumAmount = premiumAmount + "%";
				}
			}
			return premiumAmount;
		},
		[paycheck]
	);

	const getCoverageDetails = useCallback(() => {
		const _coverageDetails: any[] = [];
		if (openEnrollment === null || paycheck === null) {
			return;
		}
		const {
			plan: { coverage }
		} = openEnrollment;
		if (coverage.EE.active === true) {
			const premiumAmount = getPremiumAmount(coverage.EE);

			_coverageDetails.push({
				coverage: "Employee Only",
				premiumAmount
			});
		}
		if (coverage.ES.active === true) {
			const premiumAmount = getPremiumAmount(coverage.ES);
			_coverageDetails.push({
				coverage: "Coverage For Spouse",
				premiumAmount
			});
		}
		if (coverage.EC.active === true) {
			const premiumAmount = getPremiumAmount(coverage.EC);
			_coverageDetails.push({
				coverage: "Coverage For Child(ren)",
				premiumAmount
			});
		}
		// if (coverage.ECH.active === true) {
		// 	const premiumAmount = getPremiumAmount(coverage.ECH);
		// 	_coverageDetails.push({
		// 		coverage: "Coverage For Two or More Children",
		// 		premiumAmount
		// 	});
		// }
		if (coverage.ED.active === true) {
			const premiumAmount = getPremiumAmount(coverage.ED);
			_coverageDetails.push({
				coverage: "Coverage For Family",
				premiumAmount
			});
		}
		setCoverageDetails(Object.assign([], _coverageDetails));
	}, [getPremiumAmount, openEnrollment, paycheck]);

	const getPremiumRateByFixed = useCallback(
		(basePayRate: number, coverageCode: PremiumRateCoverage): number | null => {
			if (paycheck === null) {
				return null;
			}
			let premiumAmount: number | null = null;
			if (paycheck.pay_frequency === "MONTHLY") {
				premiumAmount = coverageCode.monthly_premium as number;
			} else if (paycheck.pay_frequency === "WEEKLY") {
				premiumAmount = coverageCode.weekly_premium as number;
			}
			return premiumAmount;
		},
		[paycheck]
	);

	const getPremiumRateByPercentage = useCallback(
		(basePayRate: number, coverageCode: PremiumRateCoverage): number | null => {
			if (paycheck === null) {
				return null;
			}
			let premiumAmount: number | null = null;
			if (paycheck.pay_frequency === "MONTHLY") {
				premiumAmount = (basePayRate * ((coverageCode.monthly_premium as number) / 100)) as number;
				if (premiumAmount > (coverageCode.monthly_maximum_premium as number)) {
					premiumAmount = coverageCode.monthly_maximum_premium as number;
				} else if (premiumAmount < (coverageCode.monthly_minimum_premium as number)) {
					premiumAmount = coverageCode.monthly_minimum_premium as number;
				}
			} else if (paycheck.pay_frequency === "WEEKLY") {
				premiumAmount = (basePayRate * ((coverageCode.weekly_premium as number) / 100)) as number;
				if (premiumAmount > (coverageCode.weekly_maximum_premium as number)) {
					premiumAmount = coverageCode.weekly_maximum_premium as number;
				} else if (premiumAmount < (coverageCode.weekly_minimum_premium as number)) {
					premiumAmount = coverageCode.weekly_minimum_premium as number;
				}
			}
			return premiumAmount;
		},
		[paycheck]
	);

	const calculatePremiumByCoverage = useCallback(
		(basePayRate: number, coverageCode: PremiumRateCoverage): number | null => {
			if (openEnrollment === null || paycheck === null) {
				return null;
			}

			let premiumAmount: number | null;
			if (coverageCode.active === false) {
				alert("Member is not covered in this plan");
				return null;
			}
			if (coverageCode.premium_type === "PERCENTAGE") {
				premiumAmount = getPremiumRateByPercentage(basePayRate, coverageCode);
			} else if (coverageCode.premium_type === "FIXED") {
				premiumAmount = getPremiumRateByFixed(basePayRate, coverageCode);
			} else {
				alert("Invalid premium type");
				return null;
			}
			return premiumAmount;
		},
		[getPremiumRateByFixed, getPremiumRateByPercentage, openEnrollment, paycheck]
	);

	const calculatePremium = useCallback(() => {
		if (openEnrollment === null || paycheck === null) {
			return null;
		}

		const coveredChildren: Member[] = [];
		const childrenRelationships: string[] = [
			RELATIONSHIP.child,
			RELATIONSHIP.disabled_child,
			RELATIONSHIP.legal_custody_child,
			RELATIONSHIP.stepchild,
			RELATIONSHIP.court_ordered_dependent,
			RELATIONSHIP.grandchild
		];
		let coveredSpouse: Member | any = null;
		let basePayRate: number;
		if (paycheck?.pay_frequency === "WEEKLY") {
			basePayRate = paycheck.weekly_base_rate;
		} else if (paycheck?.pay_frequency === "MONTHLY") {
			basePayRate = paycheck.monthly_base_rate;
		} else {
			alert("Invalid Pay Frequency");
			return;
		}
		let employeePremium: number | null = 0;
		employeePremium = calculatePremiumByCoverage(basePayRate, openEnrollment.plan.coverage.EE);
		if (employeePremium === null) {
			return;
		}
		coveredDependents.forEach((coveredDependent: Member) => {
			if (childrenRelationships.includes(coveredDependent.relationship as string)) {
				coveredChildren.push(coveredDependent);
			} else if (coveredDependent.relationship === RELATIONSHIP.spouse) {
				coveredSpouse = coveredDependent;
			}
		});
		const coverageCode = coveredSpouse && coveredChildren.length !== 0 ? "EF" : coveredSpouse ? "ES" : "ECH";
		const standardDetails: StandardDetails[] = [];
		let _dependentPremium = 0;
		if (coveredDependents.length !== 0) {
			if (coveredSpouse !== null) {
				const premiumAmount = calculatePremiumByCoverage(basePayRate, openEnrollment.plan.coverage.ES);
				if (premiumAmount === null) {
					alert("Invalid Premium Amount");
					return null;
				}
				const spouseStandardDetails: StandardDetails = {
					member_object_id: coveredSpouse._id,
					coverage_code: "ES",
					member_SSN: coveredSpouse.SSN,
					premium_amount: premiumAmount,
					is_tobacco: false
				};
				standardDetails.push(spouseStandardDetails);
				_dependentPremium = _dependentPremium + premiumAmount;
			}
			if (coveredChildren.length !== 0) {
				if (coveredChildren.length === 1) {
					const premiumAmount = calculatePremiumByCoverage(basePayRate, openEnrollment.plan.coverage.EC);
					if (premiumAmount === null) {
						alert("Invalid Premium Amount");
						return null;
					}
					const spouseStandardDetails: StandardDetails = {
						member_object_id: coveredChildren[0]._id,
						coverage_code: "EC",
						member_SSN: coveredChildren[0].SSN,
						premium_amount: premiumAmount,
						is_tobacco: false
					};
					_dependentPremium = _dependentPremium + premiumAmount;
					standardDetails.push(spouseStandardDetails);
				} else {
					const premiumAmount = calculatePremiumByCoverage(basePayRate, openEnrollment.plan.coverage.ECH);
					if (premiumAmount === null) {
						alert("Invalid Premium Amount");
						return null;
					}
					coveredChildren.forEach((coveredChild: Member) => {
						const spouseStandardDetails: StandardDetails = {
							member_object_id: coveredChild._id,
							coverage_code: "ECH",
							member_SSN: coveredChild.SSN,
							premium_amount: premiumAmount,
							is_tobacco: false
						};
						standardDetails.push(spouseStandardDetails);
					});
					_dependentPremium = _dependentPremium + premiumAmount;
				}
			}
			if (coveredChildren.length !== 0 && coveredSpouse !== null) {
				const premiumAmount = calculatePremiumByCoverage(basePayRate, openEnrollment.plan.coverage.ED);
				// console.log("premiumAmount=====>", premiumAmount);
				if (premiumAmount === null) {
					alert("Invalid Premium Amount");
					return null;
				}
				_dependentPremium = premiumAmount;
			}
			setEnrollmentStandardDetails(Object.assign([], standardDetails));
			setDependentPremium(_dependentPremium);
		}
		if (coveredDependents.length !== 0) {
			setTotalPremium(_dependentPremium);
		} else {
			setTotalPremium(employeePremium);
		}

		setEmployeePremium(employeePremium);
	}, [calculatePremiumByCoverage, coveredDependents, openEnrollment, paycheck]);

	// console.log("Total Premium", totalPremium);
	// console.log("Employee Premium", employeePremium);
	// console.log("Dependent Premium", dependentPremium);

	const handleActivateButtonClick = useCallback(async () => {
		if (isAgreeTerms) {
			if (member === null || openEnrollment === null) {
				return;
			}

			const currentDate = new Date() as unknown as string;
			const planStartDate = openEnrollment.plan.start_date; // -1 or 0
			const planDateComparison: number = manualDateComparator(planStartDate, currentDate);

			const effectiveDate = openEnrollment.plan.auto_approve
				? planDateComparison === -1 || planDateComparison === 0
					? getCurrentDate()
					: null
				: null;

			const healthPlanEnrollmentCommonDetails: CommonDetails = {
				agent_id: null,
				location_number: member.location.location_number,
				location_name: member.location.location_name,
				group_number: member.group_number,
				group_name: member.group.name,
				plan_object_id: openEnrollment.plan._id,
				plan_code: openEnrollment.plan.plan_code,
				plan_name: openEnrollment.plan.plan_name,
				base_plan_name: openEnrollment.plan.plan_name,
				insured_object_id: member._id,
				insured_SSN: member.SSN,
				writing_number: 0,
				unenrolled_reason: null,
				waive_reason: null,
				termination_reason: null,
				enrollment_date: getCurrentDate(),
				effective_date: effectiveDate,
				termination_date: null,
				open_enrollment_id: openEnrollment._id,
				total_premium: totalPremium,
				has_another_group_insurance: anotherInsurance.has_another_group_insurance,
				another_group_insurance: anotherInsurance.another_group_insurance
			};

			const GLTDEnrollmentCommonDetails: CommonDetails = {
				agent_id: null,
				location_number: member.location.location_number,
				location_name: member.location.location_name,
				group_number: member.group_number,
				group_name: member.group.name,
				plan_object_id: GLTDPlan._id,
				plan_code: GLTDPlan.plan_code,
				plan_name: GLTDPlan.plan_name,
				base_plan_name: GLTDPlan.plan_name,
				insured_object_id: member._id,
				insured_SSN: member.SSN,
				writing_number: 0,
				unenrolled_reason: null,
				waive_reason: null,
				termination_reason: null,
				enrollment_date: getCurrentDate(),
				effective_date: effectiveDate,
				termination_date: null,
				open_enrollment_id: openEnrollment._id,
				total_premium: GLTDPremiumAmount as unknown as number,
				has_another_group_insurance: anotherInsurance.has_another_group_insurance,
				another_group_insurance: anotherInsurance.another_group_insurance
			};

			// This part is extra for Covered Dependent
			const childrenRelationships: string[] = [
				RELATIONSHIP.child,
				RELATIONSHIP.disabled_child,
				RELATIONSHIP.legal_custody_child,
				RELATIONSHIP.stepchild,
				RELATIONSHIP.court_ordered_dependent,
				RELATIONSHIP.grandchild
			];

			let coveredSpouse: Member | any = null;
			const coveredChildren: Member[] = [];
			coveredDependents.forEach((coveredDependent: Member) => {
				if (childrenRelationships.includes(coveredDependent.relationship as string)) {
					coveredChildren.push(coveredDependent);
				} else if (coveredDependent.relationship === RELATIONSHIP.spouse) {
					coveredSpouse = coveredDependent;
				}
			});

			const coverageCode =
				coveredSpouse === null && coveredChildren.length === 0
					? "EE"
					: coveredSpouse && coveredChildren.length !== 0
					? "EF"
					: coveredSpouse
					? "ES"
					: "ECH";

			// Extra Part ends here

			const intercityHealthPlanEnrollmentPayload: AddEnrollmentPayload = {
				common_details: healthPlanEnrollmentCommonDetails,
				standard_details: [
					...enrollmentStandardDetails,
					{
						member_object_id: member._id,
						member_SSN: member.SSN,
						coverage_code: "EE",
						premium_amount: employeePremium,
						is_tobacco: false
					}
				]
			};

			const intercityGLTDEnrollmentPayload: AddEnrollmentPayload = {
				common_details: GLTDEnrollmentCommonDetails,
				standard_details: [
					{
						member_object_id: member._id,
						member_SSN: member.SSN,
						coverage_code: "EE",
						premium_amount: GLTDPremiumAmount as unknown as number,
						is_tobacco: false
					}
				]
			};

			// console.log("intercityHealthPlanEnrollmentPayload", intercityHealthPlanEnrollmentPayload);

			const healthPlanResponse = await trackPromise(
				api.enrollment.addEnrollment(intercityHealthPlanEnrollmentPayload)
			);

			const GTDResponse = await trackPromise(api.enrollment.addEnrollment(intercityGLTDEnrollmentPayload));

			if (healthPlanResponse && GTDResponse) {
				const step = urlSearchParams.get("step");
				getEnrollmentInitData(false);
				history.push(`?step=${step}&stage=2`);
			}
		} else {
			alert("Please accept the Terms and Conditions!");
		}
	}, [
		GLTDPlan?._id,
		GLTDPlan?.plan_code,
		GLTDPlan?.plan_name,
		GLTDPremiumAmount,
		anotherInsurance.another_group_insurance,
		anotherInsurance.has_another_group_insurance,
		coveredDependents,
		employeePremium,
		enrollmentStandardDetails,
		getEnrollmentInitData,
		history,
		isAgreeTerms,
		member,
		openEnrollment,
		totalPremium,
		urlSearchParams
	]);

	const redirectBrochureDownloiad = () => {
		const pdfURL = Health_Plan_Brochure_SBC;
		const pdfTitle = "Health_Plan_Brochure SBC";
		window.open(pdfURL, pdfTitle);
	};

	const getCombinedTotal = useCallback(() => {
		if (GLTDPremiumAmount !== null && totalPremium !== null) {
			const _totalHPandGLTDpremium = GLTDPremiumAmount + totalPremium;
			setCombinedTotalPremium(_totalHPandGLTDpremium);
		}
	}, [GLTDPremiumAmount, totalPremium]);

	// <<<========== GLTD Functionalty ============>>>>

	const getGTLDPlan = useCallback(async () => {
		const GLTDPayload = {
			group_number: 188,
			plan_name: "Group Long Term Disability",
			plan_code: "ICI-GLTD-2023"
		};

		const response = await trackPromise(api.plan.getParticularPlans(GLTDPayload));

		if (response) {
			setGLTDPlan(Object.assign({}, response[0]));
		}
	}, []);

	const getGLTDPremiumAmount = useCallback(
		(premiumRateCoverage: PremiumRateCoverage): string => {
			let premiumAmount = "";
			if (paycheck) {
				if (premiumRateCoverage.premium_type === "FIXED") {
					premiumAmount =
						(paycheck.pay_frequency === "WEEKLY"
							? premiumRateCoverage.weekly_premium
							: premiumRateCoverage.monthly_premium) + "";
					premiumAmount = `${numberToDollarStr(Number(premiumAmount))}`;
				} else if (premiumRateCoverage.premium_type === "PERCENTAGE") {
					premiumAmount =
						(paycheck.pay_frequency === "WEEKLY"
							? premiumRateCoverage.weekly_premium
							: premiumRateCoverage.monthly_premium) + "";
					premiumAmount = premiumAmount + "%";
				}
			}
			return premiumAmount;
		},
		[paycheck]
	);

	const getGLTDCoverageDetails = useCallback(
		(GLTDPlan: any) => {
			const _coverageDetails: any[] = [];
			if (openEnrollment === null || paycheck === null || GLTDPlan === null) {
				return;
			}

			const GLTDCoverage = GLTDPlan.coverage;
			if (GLTDCoverage.EE.active === true) {
				const premiumAmount = getGLTDPremiumAmount(GLTDCoverage.EE);

				_coverageDetails.push({
					coverage: "For Employee Only",
					premiumAmount
				});
			}
			setGLTDCoverageDetails(Object.assign([], _coverageDetails));
		},
		[getGLTDPremiumAmount, openEnrollment, paycheck]
	);

	const getGLTDPremiumRateByFixed = useCallback(
		(basePayRate: number, coverageCode: PremiumRateCoverage): number | null => {
			if (paycheck === null) {
				return null;
			}
			let premiumAmount: number | null = null;
			if (paycheck.pay_frequency === "MONTHLY") {
				premiumAmount = coverageCode.monthly_premium as number;
			} else if (paycheck.pay_frequency === "WEEKLY") {
				premiumAmount = coverageCode.weekly_premium as number;
			}
			return premiumAmount;
		},
		[paycheck]
	);

	const getGLTDPremiumRateByPercentage = useCallback(
		(basePayRate: number, coverageCode: PremiumRateCoverage): number | null => {
			if (paycheck === null) {
				return null;
			}
			let premiumAmount: number | null = null;
			if (paycheck.pay_frequency === "MONTHLY") {
				premiumAmount = (basePayRate * ((coverageCode.monthly_premium as number) / 100)) as number;
				if (premiumAmount > (coverageCode.monthly_maximum_premium as number)) {
					premiumAmount = coverageCode.monthly_maximum_premium as number;
				} else if (premiumAmount < (coverageCode.monthly_minimum_premium as number)) {
					premiumAmount = coverageCode.monthly_minimum_premium as number;
				}
			} else if (paycheck.pay_frequency === "WEEKLY") {
				premiumAmount = (basePayRate * ((coverageCode.weekly_premium as number) / 100)) as number;
				if (premiumAmount > (coverageCode.weekly_maximum_premium as number)) {
					premiumAmount = coverageCode.weekly_maximum_premium as number;
				} else if (premiumAmount < (coverageCode.weekly_minimum_premium as number)) {
					premiumAmount = coverageCode.weekly_minimum_premium as number;
				}
			}
			return premiumAmount;
		},
		[paycheck]
	);

	const calculateGLTDPremiumByCoverage = useCallback(
		(basePayRate: number, coverageCode: PremiumRateCoverage): number | null => {
			if (openEnrollment === null || paycheck === null) {
				return null;
			}

			let premiumAmount: number | null;
			if (coverageCode.active === false) {
				alert("Member is not covered in this plan");
				return null;
			}
			if (coverageCode.premium_type === "PERCENTAGE") {
				premiumAmount = getGLTDPremiumRateByPercentage(basePayRate, coverageCode);
			} else if (coverageCode.premium_type === "FIXED") {
				premiumAmount = getGLTDPremiumRateByFixed(basePayRate, coverageCode);
			} else {
				alert("Invalid premium type");
				return null;
			}
			return premiumAmount;
		},
		[getGLTDPremiumRateByFixed, getGLTDPremiumRateByPercentage, openEnrollment, paycheck]
	);

	const calculateGLTDPremium = useCallback(
		(GLTDPlan: any) => {
			if (openEnrollment === null || paycheck === null) {
				return null;
			}

			let basePayRate: number;
			if (paycheck?.pay_frequency === "WEEKLY") {
				basePayRate = paycheck.weekly_base_rate;
			} else if (paycheck?.pay_frequency === "MONTHLY") {
				basePayRate = paycheck.monthly_base_rate;
			} else {
				alert("Invalid Pay Frequency");
				return;
			}
			let employeePremium: number | null = 0;
			const GLTDCoverageEE = GLTDPlan.coverage.EE;
			employeePremium = calculateGLTDPremiumByCoverage(basePayRate, GLTDCoverageEE);
			setGLTDPremiumAmount(Number(employeePremium?.toFixed(2)));
			if (employeePremium === null) {
				return;
			}
			if (openEnrollment) {
				// setCurrentEnrollment(
				// 	Object.assign(
				// 		{},
				// 		{
				// 			plan_name: openEnrollment.plan.plan_name,
				// 			status: "Current",
				// 			premium_amount: employeePremium
				// 		}
				// 	)
				// );
			}
		},
		[calculateGLTDPremiumByCoverage, openEnrollment, paycheck]
	);

	const handleAddDependentClick = useCallback(() => {
		history.push("/home/add-family-member");
	}, [history]);

	useEffect(() => {
		if (openEnrollment) {
			const dependentCoverage = getHealthPlanEligibleDependents(dependents, openEnrollment.plan.coverage);
			setEligibleDependents(Object.assign([], dependentCoverage.eligibleDependents));
			getCoverageDetails();
			setEligiblityDialogProps((prevEligiblityDialogProps: EligiblityDialogProps) => {
				return Object.assign({}, prevEligiblityDialogProps, {
					openDialog: true,
					eligibleDependents: Object.assign([], dependentCoverage.eligibleDependents),
					ineligibleRelationshipDependents: Object.assign(
						[],
						dependentCoverage.ineligibleRelationshipDependents
					),
					ineligibleDependents: Object.assign([], dependentCoverage.ineligibleDependents)
				});
			});
		}
	}, [dependents, getCoverageDetails, openEnrollment]);

	useEffect(() => {
		getGTLDPlan();
		getCombinedTotal();
		calculatePremium();
	}, [calculatePremium, coveredDependents.length, getCombinedTotal, getGTLDPlan]);

	useEffect(() => {
		if (GLTDPlan) {
			getGLTDCoverageDetails(GLTDPlan);
			calculateGLTDPremium(GLTDPlan);
		}
	}, [GLTDPlan, calculateGLTDPremium, getGLTDCoverageDetails]);

	useEffect(() => {
		if (submitWaiveFormStatus && waiveCoverageForm) handleWaiveSubmition(waiveCoverageForm);

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [submitWaiveFormStatus, waiveCoverageForm]);

	return (
		<div className="health-benefit">
			<Suspense fallback={<div />}>
				{customFormDialogProps ? (
					<LazyCustomWaiveFormDialog
						customFormDialogProps={customFormDialogProps}
						handleDialogClose={handleDialogClose}
						date={dateTimeZoneConverter(getCurrentDate()) as unknown as string}
					/>
				) : null}
			</Suspense>
			<Suspense fallback={<div />}>
				<EligiblityDialog eligiblityDialogProps={eligiblityDialogProps} />
			</Suspense>

			<div className="paper-form-container">
				<Paper className="theme-border-radius paper-container" elevation={1}>
					<PlanHeader planName={"Health Plan"} planCode={openEnrollment?.plan.plan_code} />
					<div className="theme-plan-section-margin" />
					<CoverageDetails coverageDetails={coverageDetails} titleHeader="Health Plan" />
					<div className="theme-plan-section-margin" />
					{eligibleDependents.length > 0 ? (
						<CoveredDependents
							dependents={eligibleDependents}
							handleSelectDependent={handleSelectDependent}
						/>
					) : (
						<div className="grid-actions-container">
							<div className="grid-action-margin" />
							<Button
								variant="contained"
								className="plan-action-button"
								style={{
									float: "right",
									marginBottom: "1rem",
									color: theme.button.color,
									backgroundColor: theme.button.background_color
								}}
								onClick={handleAddDependentClick}
							>
								Add Dependent
							</Button>
						</div>
					)}

					<Grid className="grid-container" container columnSpacing={2}>
						<Grid container columnSpacing={2}>
							<Grid item xl={4} lg={4} md={4} sm={5} xs={6}>
								<div className="details-form-label  required">Group Plan</div>
							</Grid>
							<Grid item xl={3} lg={3} md={3} sm={5} xs={6}>
								<div className="details-form-row">
									<div className="details-form-label"></div>
								</div>
							</Grid>
							<Grid item xl={3} lg={3} md={3} sm={5} xs={6}>
								<div className="details-form-row">
									<div className="details-form-label"></div>
								</div>
							</Grid>
							<Grid item xl={2} lg={2} md={2} sm={2} xs={6}>
								<div className="details-form-row">
									<div className="details-form-label required align-center">Premium</div>
									<div className="show-premium"></div>
								</div>
							</Grid>
						</Grid>

						<Grid container columnSpacing={2}>
							<Grid item xl={5} lg={5} md={3} sm={5} xs={6}>
								<div style={{ display: "flex" }}>
									<div className="checkbox-label details-form-row">
										<div className="details-form-label">Health Plan</div>
									</div>
								</div>
							</Grid>
							<Grid item xl={5} lg={5} md={3} sm={5} xs={6}></Grid>
							<Grid item xl={2} lg={2} md={3} sm={2} xs={6}>
								<div className="details-form-row margin-top-minus-8">
									<div className="show-premium">$ {totalPremium}</div>
								</div>
							</Grid>
						</Grid>
					</Grid>

					<div className="theme-plan-section-margin" />

					<div>
						<div className="header-container header-container-new">
							<div className="theme-plan-header">Group Long Term Disability</div>
						</div>
						<div
							className="theme-plan-sub-header plan-text"
							style={{ borderLeftColor: theme.primary_color }}
						>
							In addition to Health Plan, it is necessary to opt in for Group Long Term Disability.
						</div>
						<Grid className="grid-container" container columnSpacing={2}>
							<Grid container columnSpacing={2}>
								<Grid item xl={4} lg={4} md={4} sm={5} xs={6}>
									<div className="details-form-label  required">Group Plan</div>
								</Grid>
								<Grid item xl={3} lg={3} md={3} sm={5} xs={6}>
									<div className="details-form-row">
										<div className="details-form-label  required">Coverage For</div>
										{/* <Select
											input={<CustomSelectInput />}
											style={{ width: "100%" }}
											name="contact_label"
											onChange={(event: any) => handleCoverageChange(event)}
										>
											{wholeLifePlan.coverage.map((option: string, index: number) => {
												{
													if (option === "Employee Only" || option === "Employee & Spouse") {
														return (
															<MenuItem value={option} key={index}>
																{option}
															</MenuItem>
														);
													}
												}
											})}
										</Select> */}
									</div>
								</Grid>
								<Grid item xl={3} lg={3} md={3} sm={5} xs={6}>
									<div className="details-form-row">
										<div className="details-form-label  required">Premium Value</div>
										{/* <Select
											input={<CustomSelectInput />}
											style={{ width: "100%" }}
											name="member_face_amount"
											onChange={(event: SelectChangeEvent) => handlePlanChange(event)}
										>
											{wholeLifePlan.coverage_level.map((coverage, index) => {
												return (
													// eslint-disable-next-line react/jsx-key
													<MenuItem value={coverage === null ? "" : coverage}>
														{coverage === null ? "Select" : coverage}
													</MenuItem>
												);
											})}
										</Select> */}
									</div>
								</Grid>
								<Grid item xl={2} lg={2} md={2} sm={2} xs={6}>
									<div className="details-form-row">
										<div className="details-form-label required align-center">Premium</div>
										<div className="show-premium">
											{/* <div className="show-premium">
												{memberWeeklyPremium == 0
													? "$0.00"
													: `$${memberWeeklyPremium && memberWeeklyPremium.toFixed(2)}`}
											</div> */}
										</div>
									</div>
								</Grid>
							</Grid>

							<Grid container columnSpacing={2}>
								<Grid item xl={4} lg={4} md={4} sm={4} xs={4}>
									<div style={{ display: "flex" }}>
										{/* <Checkbox
											checked={hasMemberWaiverPremium}
											style={{ paddingLeft: 0 }}
											onChange={handleWaiverPremiumChange}
											name="member-waiver-premium"
											className="margin-fix"
											disabled={true}
										/> */}
										<Checkbox
											checked={true}
											style={{ paddingLeft: 0 }}
											onChange={() => null}
											name="member-death-chronic-illness"
											className="margin-fix"
											disabled={true}
										/>
										<div className="checkbox-label details-form-row">
											<div className="details-form-label">Group Long Term Disability</div>
										</div>
									</div>
								</Grid>
								<Grid item xl={3} lg={3} md={3} sm={3} xs={3}>
									<div>{GLTDcoverageDetails[0]?.coverage}</div>
								</Grid>
								<Grid item xl={3} lg={3} md={3} sm={3} xs={3}>
									<div>
										{GLTDcoverageDetails[0]?.premiumAmount} of {paycheck?.pay_frequency} Pay
									</div>
								</Grid>
								<Grid item xl={2} lg={2} md={2} sm={2} xs={2}>
									<div className="details-form-row margin-top-minus-8">
										<div className="show-premium">$ {GLTDPremiumAmount}</div>
										{/* {hasMemberWaiverPremium && (
											<div className="show-premium">
												{memberWaiverPremium == 0
													? "$0.00"
													: `$${memberWaiverPremium && memberWaiverPremium.toFixed(2)}`}
											</div>
										)} */}
									</div>
								</Grid>
							</Grid>
						</Grid>
					</div>

					{/* ============================================================== (PREMIUM AMOUNT) ========================================== */}

					<div className="theme-plan-inner-section-margin-2" />
					<Grid container className="theme-plan-inner-section-margin">
						<Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
							<div className="details-form-row">
								<div
									className="details-form-label theme-plan-total-premium align-right"
									style={{ color: theme.primary_color }}
								>
									Total Premium (inc. GLTD):{" "}
									<span className="show-premium margin-adjust">
										{combinedTotalPremium == 0
											? "$0.00"
											: `$${combinedTotalPremium && combinedTotalPremium.toFixed(2)}`}
										{/* {totalPremium == 0 ? "$0.00" : `$${totalPremium && totalPremium.toFixed(2)}`} */}
									</span>
								</div>
							</div>
						</Grid>
					</Grid>

					<div className="theme-plan-option-content theme-plan-section-margin">
						<Checkbox
							onClick={handleChangeOtherInsurance}
							name="has_another_group_insurance"
							checked={anotherInsurance.has_another_group_insurance}
							style={{ paddingLeft: 0 }}
						/>
						<p className="theme-plan-checkbox-label">
							<strong>ARE YOU OR YOUR DEPENDENTS COVERED UNDER ANOTHER GROUP INSURANCE POLICY</strong>
						</p>
					</div>
					<div>
						{anotherInsurance.has_another_group_insurance ? (
							<CustomInput
								name="another_group_insurance"
								value={anotherInsurance.another_group_insurance}
								onChange={handleChangeOtherInsurance}
							/>
						) : null}
					</div>

					<div>
						<h3>Please sign below </h3>
						<div className="herby-terms-conditions">
							I hereby,
							<div className="terms-container">
								<div>
									<LinkIcon className="link-icon" style={{ color: theme.primary_color }} />
								</div>
								<div>
									Request to enroll in that{" "}
									<a href="" onClick={redirectBrochureDownloiad}>
										BENEFIT PLAN
									</a>{" "}
									for which I am or may become eligible under the Plan created by the above{" "}
									<a href="" onClick={redirectBrochureDownloiad}>
										PLAN SPONSOR
									</a>
								</div>
							</div>
							<div className="terms-container">
								<div>
									<LinkIcon className="link-icon" style={{ color: theme.primary_color }} />
								</div>
								<div>
									Reafirm that I will abide by the provisions set forth in the{" "}
									<a href="" onClick={redirectBrochureDownloiad}>
										SUMMARY PLAN DESCRIPTION
									</a>{" "}
									and{" "}
									<a href="" onClick={redirectBrochureDownloiad}>
										PLAN DOCUMENT
									</a>
								</div>
							</div>
							<div className="terms-container">
								<div>
									<LinkIcon className="link-icon" style={{ color: theme.primary_color }} />
								</div>
								<div>Authorize the required deductions, if any, from my earnings</div>
							</div>
							<div className="terms-container">
								<div>
									<LinkIcon className="link-icon" style={{ color: theme.primary_color }} />
								</div>
								<div>Certify that the above dates of birth and other information are correct</div>
							</div>
							<div className="terms-container">
								<div>
									<LinkIcon className="link-icon" style={{ color: theme.primary_color }} />
								</div>
								<div>
									I understand that cannot change or drop coverage prior to next open enrollment
									period unless a change of family and/or job status occur.
								</div>
							</div>
						</div>
					</div>

					<div className="theme-plan-section-margin" />
					{/* <div className="external-links">
						<div>
							<LinkIcon className="link-icon" style={{ color: theme.primary_color }} />
						</div>
						<div className="header">
							To Know More About The Benefits Offered,{" "}
							<a href="#" onClick={redirectBrochureDownloiad}>
								Click Here
							</a>
						</div>
					</div> */}
					<div className="theme-plan-option-content theme-plan-section-margin">
						<Checkbox
							checked={isAgreeTerms}
							onClick={handleChangeIsAgreeTerms}
							style={{ paddingLeft: 0 }}
						/>
						<p className="theme-plan-checkbox-label">
							<strong>
								I UNDERSTAND AND AGREE TO THE TERMS AND CONDITIONS STATED ABOVE AND AUTHORIZE
								THE&nbsp;PAYROLL DEDUCTIONS TO BE MADE AS INDICATED
							</strong>
						</p>
					</div>
					<div className="theme-plan-section-margin" />
					<Grid container className="theme-plan-section-margin">
						<Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
							<div className="details-form-row">
								<div className="details-form-label  required">Signature</div>
								<CustomInput value={member?.first_name + " " + member?.last_name} disabled />
							</div>
						</Grid>
						<Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
							<div className="details-form-row">
								<div className="details-form-label  required">Date</div>
								<CustomInput value={dateTimeZoneConverter(getCurrentDate())} disabled />
							</div>
						</Grid>
					</Grid>
					<div className="theme-plan-section-margin" />
					<PlanActions
						waiveButtonCallback={handleWaiveButtonClick}
						activateButtonCallback={handleActivateButtonClick}
					/>
				</Paper>
			</div>
		</div>
	);
};

export default IntercityHealthPlanForm;
